/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Bryan Sheranian <bryan.sheranian@deliciousai.com>
 */

import { gql } from '@apollo/client'
import { GROUP_FRAGMENT } from '../fragments'

export const DELETE_GROUP = gql`
  mutation DeleteGroup($id: ID!) {
    deleteGroup(id: $id) {
      success
      deletedGroup {
        ...Group
      }
    }
  }
  ${GROUP_FRAGMENT}
`
